import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";
import {icJWT_Account, LabInfo, NJPOPSearchParams} from "../NIBINInterface";
import axios from "axios";
import {MatSnackBar} from "@angular/material/snack-bar";
import Swal from "sweetalert2";

@Injectable()
export class EmailService {
  user: icJWT_Account = <icJWT_Account>{};

  constructor(private authService:AuthService, private matSnackBar: MatSnackBar) {
    this.user = this.authService.getUser()
  }

  public async getEmailReportLogs(reportid : string): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/getReportEmailLogs?ReportID='+reportid,null, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Email Email Logs",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async getEmailList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/getEmailList?Dept='+this.user.CurrentDept,params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Email List",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }
  public async getEmailListInGroup(group:string): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/getEmailListInGroup?Dept='+this.user.CurrentDept+'&Group='+group,{}, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Email List (Group)",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async getEmailGroups(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/getEmailGroups?Dept='+this.user.CurrentDept,params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Email Groups",
        timerProgressBar:true,
        timer:3000
      })
      return []
    }
  }

  public async addEmailToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/addEmailToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to add Email",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async addGroupToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/addGroupToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to add Group",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async removeEmailToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/rmEmailToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Remove Email",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async updateEmailOnList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/updateEmailOnList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Update Email Record",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async removeGroupToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/rmGroupToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to remove Group",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

  public async sendNIBINReportEmail(params:any): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Email/sendNIBINEmail',params, {headers:{authToken:this.authService.getUser().apikey}})
      Swal.fire({
        icon: 'success',
        title: 'System Notification',
        text: "Email Successfully Sent",
        timerProgressBar:true,
        timer:4000
      })
      return result.data;
    }
    catch (e) {

      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Rate limited or error occurred while sending Email",
        timerProgressBar:true,
        timer:10000
      })

      throw e;
    }

  }

  public async getReplyToEmailList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/getReplyToEmailList?Dept='+this.user.CurrentDept,params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Email List",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }
  public async addReplyToEmailToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/addReplyToEmailToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to add Email",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }
  public async updateReplyToEmailOnList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/updateReplyToEmailOnList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Update Email Record",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }
  public async removeReplyToEmailToList(params:any): Promise<any[]>{
    try{
      let result = await axios.post('/NIBIN/Email/rmReplyToEmailToList',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Remove Email",
        timerProgressBar:true,
        timer:3000
      })

      return []
    }
  }

}
